<template>
  <md-toolbar
    v-if="computedTitle"
    md-elevation="0"
    :class="{
      'md-toolbar-absolute md-dark md-fixed-top': $route.meta.navbarAbsolute,
    }"
  >
    <div class="md-toolbar-row">
      <div class="md-toolbar-section-start" v-if="computedTitle">
        <h3 class="md-title navbar-title">{{ computedTitle }} Dashboard</h3>
      </div>
      <div class="md-toolbar-section-end">
        <div class="navbar-logo">
          <img src="/img/cotozere.png" alt="CoToZere" />
        </div>
        <md-button
          class="md-just-icon md-round md-simple md-toolbar-toggle"
          :class="{ toggled: $sidebar.showSidebar }"
          @click="toggleSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>
        <!--
        <div class="md-collapse">
          <div class="md-autocomplete">
            <md-autocomplete
              class="search"
              v-model="selectedEmployee"
              :md-options="employees"
              :md-open-on-focus="false"
            >
              <label v-if="$route.meta.rtlActive">بحث...</label>
              <label v-else>Search...</label>
            </md-autocomplete>
          </div>
          <md-list>
            <md-list-item href="#/">
              <i class="material-icons">dashboard</i>
              <p class="hidden-lg hidden-md">Dashboard</p>
            </md-list-item>

            <li class="md-list-item">
              <a
                href="#/components/notifications"
                class="md-list-item-router md-list-item-container md-button-clean dropdown"
              >
                <div class="md-list-item-content">
                  <drop-down direction="down">
                    <md-button
                      slot="title"
                      class="md-button md-just-icon md-simple"
                      data-toggle="dropdown"
                    >
                      <md-icon>notifications</md-icon>
                      <span class="notification">5</span>
                      <p class="hidden-lg hidden-md">Notifications</p>
                    </md-button>
                    <ul class="dropdown-menu dropdown-menu-right">
                      <li><a href="#">Mike John responded to your email</a></li>
                      <li><a href="#">You have 5 new tasks</a></li>
                      <li><a href="#">You're now friend with Andrew</a></li>
                      <li><a href="#">Another Notification</a></li>
                      <li><a href="#">Another One</a></li>
                    </ul>
                  </drop-down>
                </div>
              </a>
            </li>

            <md-list-item href="#/pages/user">
              <i class="material-icons">person</i>
              <p class="hidden-lg hidden-md">Profile</p>
            </md-list-item>
          </md-list>
        </div>
      --></div>
    </div>
  </md-toolbar>
</template>

<script>
import { classroomByPath } from "@/utils/userInfo.js";
export default {
  data() {
    return {
      selectedEmployee: "",
      employees: [
        "Jim Halpert",
        "Dwight Schrute",
        "Michael Scott",
        "Pam Beesly",
        "Angela Martin",
        "Kelly Kapoor",
        "Ryan Howard",
        "Kevin Malone",
      ],
      isMobile: false,
    };
  },

  computed: {
    computedTitle() {
      if (this.$route.name === "Classroom Dashboard") {
        return classroomByPath[this.$route.path].name;
      }
      return "Energetický";
    },
  },

  mounted() {
    this.checkMobile();
    window.addEventListener("resize", this.checkMobile);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.checkMobile);
  },

  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 991;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
  },
};
</script>

<style scoped>

.md-toolbar {
  background: linear-gradient(135deg, #1a2332 0%, #0f1624 100%) !important;
  border-bottom: 1px solid #374151 !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3) !important;
  z-index: 0 !important;
}

 .md-toolbar.md-dark {
  background: linear-gradient(135deg, #1a2332 0%, #0f1624 100%) !important;
}

.md-toolbar-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 20px;
}

.md-toolbar-section-start .md-title {
  color: #f3f4f6 !important;
  font-weight: 700;
  font-size: 1.5em;
  letter-spacing: 0.3px;
}

.navbar-title {
  font-size: 1.5em !important;
  font-weight: 600 !important;
}

/* Responzívny text na tabletoch a mobiloch */
@media (max-width: 768px) {
  .navbar-title {
    font-size: 1.1em !important;
  }
}

@media (max-width: 576px) {
  .navbar-title {
    font-size: 0.85em !important;
  }
}

.md-toolbar-section-end {
  display: flex;
  gap: 12px;
  align-items: center;
}

.md-toolbar-toggle {
  color: #f3f4f6 !important;
  transition: all 0.3s ease !important;
}

.md-toolbar-toggle:hover {
  color: #6366f1 !important;
  background: rgba(99, 102, 241, 0.1) !important;
}

.md-toolbar-toggle .icon-bar {
  background: #f3f4f6 !important;
  transition: all 0.3s ease !important;
}

.md-toolbar-toggle.toggled .icon-bar {
  background: #6366f1 !important;
}

.md-autocomplete {
  background: #0f1624 !important;
  border-color: #374151 !important;
  color: #f3f4f6 !important;
}

.md-list-item {
  color: #f3f4f6 !important;
}

.md-icon {
  color: #f3f4f6 !important;
}

.navbar-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
}

.navbar-logo img {
  max-height: 40px;
  width: auto;
  object-fit: contain;
}
</style>